
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DatabaseServersPage"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"databaseServers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fork"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"host"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"port"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastError"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serverVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUpgradeSupported"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isLTSVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isLocal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isDefaultServer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUsedForPsaDb"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isWebadminInstalled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isDynamicPort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"databasesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableReleases"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryKey"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pleskKeyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyRemoteDb"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"mode"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDemo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"os"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isWindows"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manageServerPhpmyadmin"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":677}};
    doc.loc.source = {"body":"query DatabaseServersPage {\r\n    databaseServers {\r\n        id\r\n        name\r\n        type\r\n        fork\r\n        host\r\n        port\r\n        lastError\r\n        serverVersion\r\n        isUpgradeSupported\r\n        isLTSVersion\r\n        isLocal\r\n        isDefaultServer\r\n        isUsedForPsaDb\r\n        isWebadminInstalled\r\n        isDynamicPort\r\n        databasesCount\r\n        availableReleases {\r\n            id\r\n        }\r\n    }\r\n    primaryKey {\r\n        pleskKeyId\r\n        keyRemoteDb\r\n    }\r\n    mode {\r\n        isDemo\r\n    }\r\n    os {\r\n        isWindows\r\n    }\r\n    viewer {\r\n        login\r\n        permissions {\r\n            manageServerPhpmyadmin\r\n        }\r\n    }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DatabaseServersPage"] = oneQuery(doc, "DatabaseServersPage");
        
